
import { defineComponent, computed, ref } from 'vue'
import { useModal } from './composables/useModal'
import { required, length, validate, Status } from './utils/validators'
// import { provideStore } from './store'
import { provideStore } from './store'
import NavBar from './components/common/NavBar.vue'

export default defineComponent({
  name: 'App',
  components: {
    NavBar,
  },

  setup () {

    provideStore()
    const modal = useModal()
    const username = ref('username')
    
    // derive validity of username in computed property
    // typed as status
    const usernameStatus = computed<Status>(() => {
      return validate(
        username.value, 
        [
          required(),
          length({
            min: 5,
            max: 20
          })
        ]
      )
    })

    const style = computed(() => ({
      display: modal.visible.value ? 'block' : 'none'
    }))

    return {
      style,
      modal,
      username,
      usernameStatus
    }
  }
})
